import { Component, computed, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { CommonModule, LowerCasePipe } from "@angular/common";
import { ServiceType } from "../../../../../pages/subscription-detail/types";
import { ServiceSpeedPipe } from "../../../../../pages/subscription-detail/components/service-speed-pipe/service-speed-pipe";

@Component({
  selector: "service-row",
  templateUrl: "service-row.html",
  imports: [AngularSvgIconModule, CommonModule, LowerCasePipe, ServiceSpeedPipe, TranslateModule],
})
export class ServiceRowComponent {
  protected service = input.required<ServiceType>();
  protected active = input.required<boolean>();

  private product = computed(() => this.service().product);
  private productTag = computed(() => this.product().tag);
  protected productType = computed(() => this.product().type);

  protected isFirewall = computed(() => this.productType() === "FW");
  protected isMsc = computed(() => this.productTag() === "MSC");

  protected serviceSpeed = computed(() => this.service().speed);
  protected title = computed(() => this.service().customerDescription ?? this.service().description);
}
